export const APP_SET_SETTINGS = '@UI/APP/SET_SETTINGS';
